<template>
  <div class="flex-1">
    <div class="flex items-center">
      <div
        class="flex-grow mr-2"
        @click="showModal"
      >
        <input
          class="text-sm py-1 w-full pl-2 font-light pointer-events-none text-blue-dark text-opacity-50"
          type="text"
          :placeholder="model.placeholderText"
        >
        <input
          ref="fakeInput"
          type="text"
          style="position: absolute;left: 0;width: 100%;bottom: 0;opacity: 0;height: 0;"
        >
      </div>
      <button
        v-if="!store.state.tags.length && !store.state.searchTerms.length"
        type="button"
        class="inline-flex ml-auto w-8 h-8 items-center justify-center mr-1"
      >
        <SearchIcon />
      </button>
    </div>
    <Portal>
      <div
        v-if="store.state.isMobileAutocompleteVisible"
        class="absolute bg-white left-0 top-0 w-full h-full z-50"
      >
        <div
          class="facet-search-bar-modal relative w-full h-full flex flex-col flex-shrink-0 oveflow-hidden"
          :class="{
            'is-focused': isFocused
          }"
        >
          <div class="bg-blue-dark px-4 py-4 md:py-6">
            <div class="flex flex-shrink-0 justify-end">
              <span
                role="button"
                @click="close"
              >
                <IconCross
                  width="20px"
                  height="20px"
                  stroke="white"
                />
              </span>
            </div>
            <h4 class="text-white text-2xl">
              {{ model.mobileModalWindowHeading }}
            </h4>
          </div>
          <div class="px-4 py-6 flex-1 overflow-hidden">
            <SearchBarAutocomplete
              class="flex-shrink-0 relative h-full"
              :model="model"
              :is-mobile="true"
              :focus-on-show-up="true"
              @focus-changed="onFocusChanged"
            />
          </div>
        </div>
      </div>
    </Portal>
  </div>
</template>
<script>
import store from '@/components/facet/store'
import SearchIcon from '@/assets/icons/search-icon.svg'
import IconCross from '@/assets/icons/icon-cross.svg'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { Portal } from '@linusborg/vue-simple-portal'
import SearchBarAutocomplete from '@/components/facet/SearchBarAutocomplete.vue'

export default {
  components: {
    IconCross,
    SearchIcon,
    Portal,
    SearchBarAutocomplete
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      store,
      isFocused: false
    }
  },
  computed: {
    placeholder() {
      const tags = this.store.state.tags.map((tag) => tag.name)
      const { searchTerms } = this.store.state
      const { placeholderText } = this.model
      const placeholder = [...tags, ...searchTerms].join(' + ')
      return placeholder || placeholderText
    }
  },
  watch: {
    'store.state.isMobileAutocompleteVisible': {
      handler(visible) {
        if (visible) {
          disableBodyScroll()
        } else {
          enableBodyScroll()
        }
      }
    }
  },
  methods: {
    showModal() {
      this.$refs.fakeInput.focus()
      this.store.dispatch('setMobileAutoCompleteVisibility', { value: true })
    },
    close() {
      this.store.dispatch('setMobileAutoCompleteVisibility', { value: false })
    },
    onFocusChanged(value) {
      this.isFocused = value
    }
  }
}
</script>

<style>
.facet-search-bar-modal.is-focused {
  padding-bottom: 33vh;
}
</style>
